export default __webpack_public_path__ + "static/media/vertices.e6339806.svg";